module.exports = __webpack_public_path__ + "img/imageCardFour.51e73bc6.png";